import { DescriptionRole } from "@/models/api/administration/roles/DescriptionRole";

export class RoleDescription extends DescriptionRole {
  id: string;
  name: string;
  officeId: string;

  constructor(apiRoleModel: DescriptionRole, id: string, name: string, officeId: string) {
    super();
    Object.assign(this, apiRoleModel);
    this.id = id;
    this.name = name;
    this.officeId = officeId;
  }
}
